import { cn } from '@anytag/shared-utils';
import { ComboboxDropdown, ComboboxDropdownProps } from '@anyui/core';
import { useSelectContext } from '../select-context';

export type SelectDropdownProps = ComboboxDropdownProps;

export const SelectDropdown = ({ className, children, ...restProps }: SelectDropdownProps) => {
  const {
    selectProps: { classNames, dropdownAlignment }
  } = useSelectContext();

  return (
    <ComboboxDropdown
      onCloseAutoFocus={(e) => e.preventDefault()} // Prevent auto focus again after dropdown is closed
      className={cn(
        'min-w-[max(var(--radix-popover-trigger-width),12rem)]',
        'max-w-[min(calc(var(--radix-popover-trigger-width)*2),40rem)]',
        className,
        classNames?.dropdown
      )}
      {...restProps}
      {...dropdownAlignment}
    >
      {children}
    </ComboboxDropdown>
  );
};
